import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59ba168a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=59ba168a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba168a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ba168a')) {
      api.createRecord('59ba168a', component.options)
    } else {
      api.reload('59ba168a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=59ba168a&scoped=true", function () {
      api.rerender('59ba168a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/newAccount/index.vue"
export default component.exports